export default __webpack_public_path__ + "static/media/DataStems_Logo_Stacked.8044b97a.png";